module.exports = __webpack_public_path__ + "static/media/booking_empty.60d07044.svg";